import Header from "./Header";

const About = () => {
    return (
        <>
            <Header />
            <div class="container">
                <div class="about">
                    <h1>about the appp</h1>
                    <p>
                        Lorem ipsum dolor sit, amet consectetur adipisicing
                        elit. Excepturi dicta veritatis nulla, autem laboriosam,
                        expedita nobis quos consectetur eius incidunt, pariatur
                        possimus assumenda? Voluptas deleniti, iste sequi magnam
                        autem laudantium!
                    </p>

                    <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Temporibus libero error repellat. Animi quia
                        ducimus perspiciatis enim reprehenderit iusto voluptate
                        debitis reiciendis laboriosam ab aliquid delectus eaque
                        harum, expedita placeat? Nam corrupti exercitationem
                        quas, modi consequuntur consectetur possimus culpa
                        dolore corporis itaque fugit, nostrum qui nisi. Quo
                        inventore sit dolore ut adipisci possimus deserunt
                        assumenda ducimus earum quos, perferendis et tempora
                        omnis vero aliquid ea distinctio magni eum, facilis
                        vitae totam sed, numquam delectus excepturi! Magnam
                        eaque fuga voluptas architecto at! Itaque laborum
                        quisquam veritatis molestias a iure id, vel totam unde,
                        aut eligendi debitis ipsam doloribus ea, deleniti
                        reiciendis.
                    </p>

                    <p>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Impedit eius voluptatum, natus, aliquam ipsa
                        fugiat similique dolores voluptatem rem sapiente
                        laborum, praesentium doloribus fugit neque eum ducimus
                        sed saepe sequi quibusdam autem porro veniam deserunt
                        dicta. Suscipit nostrum maxime hic voluptate, quo quae
                        ea ipsam. Vero necessitatibus ipsa iste neque!
                    </p>
                </div>
            </div>
        </>
    );
};

export default About;
